import apiClient from '@/services/apiClient';
import type { ApiResponse } from '@/types/api';
import type { AdminSearchResults } from '@/types/admin';

/** 后台全局搜索（用户 / 订单 / 配套，按管理员权限返回分组） */
export async function searchAdmin(q: string, limit = 5) {
  const { data } = await apiClient.get<ApiResponse<AdminSearchResults>>('/admin/search', {
    params: { q, limit },
  });
  return data.data;
}
